import axios from 'axios';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import AlertLabel from '../../component/AlertLabel';
import { RenderDatePicker, RenderSearchForm } from '../../component/formInput';
import InvoiceStatus from '../../component/InvoiceStatus';
import InvoiceStatusSelect from '../../component/InvoiceStatusSelect';
import Pagination from '../../component/Pagination';
import PaymentTypeSelect from '../../component/PaymentTypeSelect';
import { StringUtils } from '../../utils/javascriptUtils';

var numeral = require('numeral');
var _ = require('lodash');

// Tính toán tiền dịch vụ.
function ItemPrice(item) {
  let item_price = item.price;
  if(!item.is_upgrade && !item.price_is_year) {
    item_price = item.price * item.month * item.quantity
  }
  return item_price;
}

function InvoiceRows(invoice_data) {
    const inner_invoice_rows = _.map(invoice_data,(i, key) => {
      return (
        <tr key={key}>
          <td>
            {i.invoice.code}
          </td>
          <td>
            <Link to={"#"}>{i.invoice.user.email}</Link>
            <br/>
            {i.invoice.user.agency && !i.invoice.user.agency.has_custom_brand && <small className="text-muted"> <strong>Đại lý:</strong> {i.invoice.user.agency.agency_admin.email}</small>}
            {i.invoice.user.agency && i.invoice.user.agency.has_custom_brand && <small className="text-muted"> <strong>Thương hiệu riêng:</strong> {i.invoice.user.agency.agency_admin.email}</small>}
            {!i.invoice.user.agency && <small className="text-muted"> <strong>Khách lẻ</strong> </small>}
          </td>	
          <td>
            <strong>{i.product.name}</strong>
            <br/>
            <small className="text-muted">
              {i.product.code}
              <br/>
              {i.domain}
            </small>
          </td>
          <td>
            {i.invoice.payment_date}
          </td>
          <td>
            {numeral(ItemPrice(i)).format('0,0')} đ
          </td>
        </tr>
      )
    })
  return inner_invoice_rows;
}

class InvoiceRelatedTable extends React.Component {
  constructor(props) {
    super(props);
    const {customer_id, year} = this.props.routeProps.match.params;
    this.state = {
      table_data: [],
      table_query: {
        current_page: 1,
        number_of_row: 50,
        customer_id: customer_id,
        year: year
      },
      invoice_static: null
    }
  }

  componentDidMount() {
    this.listReload(this.state.table_query);
  }
  
  listReload = (table_query) => {
    const self = this;
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/agency/total/sales/related/invoice',
      withCredentials: true,
      data: table_query
    }).then(function (response) {
      self.setState({
        ...self.state,
        table_query: table_query,
        table_data: response.data.data
      })
    });
  }

  gotoPage = (page) => {
    const table_query = {
      ...this.state.table_query,
      current_page: page
    };
    this.listReload(table_query);
  }

  render() {
    const {table_query, table_data} = this.state;

    return(
      table_data && <React.Fragment> 
        <div className="page-header">
          <h4>
            <i className="icon-paragraph-justify2"></i>
            <span className="text-semibold"> Danh sách đơn hàng liên quan</span>
          </h4>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="table-responsive">
                <table className="table table-togglable table-hover default footable-loaded footable">
                  <thead>
                    <tr>
                      <th>Mã Đơn Hàng</th>
                      <th>Khách Hàng</th>
                      <th>Dịch Vụ</th>
                      <th>Ngày Thanh Toán</th>
                      <th>Tổng Tiền</th>
                    </tr>
                  </thead>
                  <tbody>
                    {table_data.data && InvoiceRows(table_data.data)}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination query={table_query} data={table_data} handle={this.gotoPage}/>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapState = state => ({
  userProfile: state.userProfile.data,
  role_path: state.userProfile.role_path,
});

const mapDispatch = (dispatch) => ({

});

export default connect(mapState, mapDispatch)(withRouter(InvoiceRelatedTable));